import { render } from "./AdminDialog.vue?vue&type=template&id=ce5a48f2&scoped=true"
import script from "./AdminDialog.vue?vue&type=script&lang=js"
export * from "./AdminDialog.vue?vue&type=script&lang=js"

import "./AdminDialog.vue?vue&type=style&index=0&id=ce5a48f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce5a48f2"]])

export default __exports__